import React, { Component } from 'react';

class Jouluvalot extends Component {

  constructor(props) {
    super(props)

    this.state = {
      flakes: [],
      canvas: undefined,
      ctx: undefined,
      mY: -100,
      mX: -100
    }
    this.initSnow = this.initSnow.bind(this);
    this.snow = this.snow.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    window.requestAnimationFrame2 = requestAnimationFrame;
    var canvas = this.refs.canvas;

    this.initSnow(canvas);
  }

  initSnow(canvas, requestAnimationFrame) {

    canvas.width = window.innerWidth;
    canvas.height = document.querySelector('body').offsetHeight;
    var flakes = this.state.flakes
    for (var i = 0; i < 50; i++) {
      var x = Math.floor(Math.random() * canvas.width),
        y = Math.floor(Math.random() * canvas.height),
        size = (Math.random() * 3) + 1,
        speed = (Math.random() * 0.2) + 0.5,
        opacity = (Math.random() * 0.5) + 0.3;

      flakes.push({
        speed: speed,
        velY: speed,
        velX: 0,
        x: x,
        y: y,
        size: size,
        stepSize: (Math.random()) / 140,
        step: 0,
        opacity: opacity
      });
    }
    window.ctx = canvas.getContext("2d");
    window.canvas = canvas;

    window.flakes = flakes
    window.addEventListener("resize", function () {
      window.canvas.width = window.innerWidth;
      window.canvas.height = document.querySelector('body').offsetHeight;
    })
    window.document.addEventListener("mousemove", function (e) {
      window.mX = e.clientX;
      window.mY = e.clientY

    });
    window.addEventListener("mousemove", function (e) {
      window.canvas.height = document.querySelector('body').offsetHeight;
    });
    window.addEventListener("scroll", function (e) {
      window.canvas.height = document.querySelector('body').offsetHeight;
    });
    this.snow();
  }


  snow() {
    var ctx = window.ctx;
    var canvas = window.canvas;
    var flakes = window.flakes;
    var mX = window.mX;
    var mY = window.mY;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    for (var i = 0; i < 50; i++) {
      var flake = flakes[i],
        x = mX,
        y = mY,
        minDist = 150,
        x2 = flake.x,
        y2 = flake.y;

      var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
        dx = x2 - x,
        dy = y2 - y;

      if (dist < minDist) {
        var force = minDist / (dist * dist),
          xcomp = (x - x2) / dist,
          ycomp = (y - y2) / dist,
          deltaV = force / 2;

        flake.velX -= deltaV * xcomp;
        flake.velY -= deltaV * ycomp;

      } else {
        flake.velX *= .98;
        if (flake.velY <= flake.speed) {
          flake.velY = flake.speed
        }
        flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
      }

      ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")";
      flake.y += flake.velY;
      flake.x += flake.velX;

      if (flake.y >= canvas.height || flake.y <= 0) {
        this.reset(flake, canvas);
      }


      if (flake.x >= canvas.width || flake.x <= 0) {
        this.reset(flake, canvas);
      }
      let flakeX = Math.round(flake.x);
      let flakeY = Math.round(flake.y);
      ctx.moveTo(flakeX, flakeY)
      ctx.arc(flakeX, flakeY, Math.round(flake.size), 0, Math.PI * 2);

    }
    ctx.fill();
    window.requestAnimationFrame2(this.snow);
  }

  reset(flake, canvas) {
    flake.x = Math.floor(Math.random() * canvas.width);
    flake.y = 0;
    flake.size = (Math.random() * 3) + 1;
    flake.speed = (Math.random() * 1) + 0.5;
    flake.velY = flake.speed;
    flake.velX = 0;
    flake.opacity = (Math.random() * 0.5) + 0.3;
  }

  render() {
    return (<><canvas ref="canvas" className="canvas"></canvas></>)
  }


}
export default Jouluvalot
